import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { BiX } from "react-icons/bi";
import { getTrivvyTitleText } from "../../pages/trivia/data";
import "./warning-modal-bwai.css";

const WarningModal = ({
  message,
  open,
  onClose,
  onOk,
  onCancel,
  type,
  selectedRows = [],
  isMessaging,
  bwai = false,
}) => {
  const [showDeleteData, setShowDeleteData] = useState(false);

  // Opt-in new look for a plain message confirm; type/isMessaging don't apply.
  if (bwai) {
    return (
      <Modal
        isOpen={open}
        toggle={onClose}
        centered
        className="bwai-modal bwai-warning-modal"
      >
        <ModalHeader
          className="bwai_modal_header"
          close={
            <BiX
              className="cursor-pointer"
              color="gray"
              size={30}
              onClick={onClose}
            />
          }
        >
          <span className="bwai_title_block">
            <span className="bwai_title_text">Confirm</span>
          </span>
        </ModalHeader>
        <ModalBody className="p-3">
          <p className="bwai-warning-message">{message}</p>
        </ModalBody>
        <ModalFooter className="bwai_popup_footer">
          <Button className="bwai_btn_outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button className="bwai_btn_danger" onClick={onOk}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <Modal isOpen={open} toggle={onClose}>
      <ModalHeader
        className={
          type === "DELETE"
            ? "trivia_modal_header_bg_delete"
            : "trivia_modal_header_bg"
        }
        toggle={onClose}
      >
        Confirm
      </ModalHeader>
      <ModalBody>
        <div>
          {message} {isMessaging ? <span>({selectedRows.length})</span> : ""}
        </div>

        {isMessaging && type == "DELETE" ? (
          <div className="mt-3">
            <div className="link-text cursor-pointer" onClick={()=>{
              setShowDeleteData(!showDeleteData)
            }}>
              Click here to {showDeleteData?"hide":"show"} messages that will be deleted
            </div>


            {
              showDeleteData &&   <div className="delete_messages_list">
              <ul>
                {selectedRows.map((x) => {
                  return <li>{getTrivvyTitleText(x)}</li>;
                })}
              </ul>
            </div>
            }

          
          </div>
        ) : (
          ""
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onOk}>
          {isMessaging ? "Yes delete these messages":"OK"} 
        </Button>
        <Button  color="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

WarningModal.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  bwai: PropTypes.bool,
};

export default WarningModal;
